module.exports = __webpack_public_path__ + "img/Sithlördchen.79c7ef19.jpg";